var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248 228V120C248 106.75 237.25 96 224 96S200 106.75 200 120V240C200 247.562 203.562 254.656 209.594 259.188L273.594 307.188C277.906 310.438 282.969 312 287.969 312C295.281 312 302.5 308.688 307.187 302.406C315.156 291.781 313 276.75 302.406 268.812L248 228ZM224 0C100.289 0 0 100.289 0 224C0 228.465 0 460.156 0 460.156C0 488.789 23.213 512 51.846 512H396.154C424.787 512 448 488.789 448 460.156C448 460.156 448 228.465 448 224C448 100.289 347.713 0 224 0ZM224 400C126.953 400 48 321.047 48 224S126.953 48 224 48S400 126.953 400 224S321.047 400 224 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDesk);
export default __webpack_public_path__ + "static/media/clock-desk.e67ac5765de451435f2141da0d57ecef.svg";
export { ForwardRef as ReactComponent };